import React, { useEffect, useState } from 'react'
import { MultiSelect, MultiSelectChangeEvent } from 'primereact/multiselect';
import {GenericComboDTO, Address, EInputTypes, InputMails, InputTextCustom} from 'medere-ui-framework'
import { useIntl } from 'react-intl';
import { Button } from 'primereact/button';
import { classNames } from 'primereact/utils';
import { ComboDataDTO } from '../../../dto/ComboDataDTO';
import CityLocationCombo from '../../CityLocationCombo';

type AddressFormProps = {
  selectedCity: ComboDataDTO | null,
  setSelectedCity: React.Dispatch<React.SetStateAction<ComboDataDTO | null>>,
  newAddress: Address,
  setNewAddress: React.Dispatch<React.SetStateAction<Address>>,
  newAddressTypes: GenericComboDTO[],
  onAddAddress: (address?: Address) => void,
  isEditing: boolean,
  cancelChanges: () => void
}

export default function AddressForm({ selectedCity, setSelectedCity, newAddress, setNewAddress, newAddressTypes, onAddAddress
  , isEditing, cancelChanges }: Readonly<AddressFormProps>) {
  const intl = useIntl();
  const [selectedAddressTypes, setSelectedAddressTypes] = useState<GenericComboDTO[]>([]);

  // ERRORS ADDRESS AREA
  const [errorType, setErrorType] = useState<boolean>(false);
  const [errorDescription, setErrorDescription] = useState<boolean>(false);
  const [errorEmail, setErrorEmail] = useState<boolean>(false);
  const [errorCity, setErrorCity] = useState<boolean>(false);

  useEffect(() => {
    if (newAddress.types.length > 0) {
      setSelectedAddressTypes(newAddress.types)
    } else {
      setSelectedAddressTypes([])
    }

  }, [newAddress])

  return (
    <div className='flex flex-column w-full mt-4 md:mt-2 '>

      <div className='flex flex-column md:flex-row flex-wrap w-12 align-items-start md:align-items-end'>
        <span className={classNames(`p-float-label md:w-5 mt w-12 md:mr-2 mr-0 ${errorType && "p-invalid"}`, { 'p-empty': newAddress.types.length == 0 })}>
          <MultiSelect
            className="inputContainer w-4"
            value={selectedAddressTypes}
            options={newAddressTypes}
            display='chip'
            optionLabel='description'
            onChange={(e: MultiSelectChangeEvent) => {
              setErrorType(false);
              setSelectedAddressTypes(e.value);
              setNewAddress({ ...newAddress, types: e.value })
            }} />
          <label className='label inputLabel' htmlFor="multiselect">Selecciona el/los tipos de dirección</label>
        </span>
        <div className='w-12 md:w-3 mr-0 md:mr-2'>
          <InputTextCustom
            label="Dirección"
            floatLabel
            error={errorDescription}
            value={newAddress.addressdesc}
            inputType={EInputTypes.TEXT}
            onChange={(e: any) => {
              setErrorDescription(false);
              setNewAddress({ ...newAddress, addressdesc: e.target.value });
            }} />
        </div>
        <InputMails value={newAddress.email} onChange={(value: string) => {
          setErrorEmail(false);
          setNewAddress({ ...newAddress, email: value });
        }} error={errorEmail} className="mb-2 pr-2 w-12 md:w-20rem" placeholder='Emails (xx@xx.xx;   yy@yy.yy;)'/>
        {/*<InputPhone
          className="mr-0 md:mr-2 w-12 md:w-5"
          inputClassname="ml-2"
          label={intl.formatMessage({ id: "Phone2" })}
          value={newAddress.telephone}
          floatLabel
          error={errorPhone}
          setValue={(val: string, field: string) => {
            setErrorPhone(false);
            let _telephone: PhoneNumber = { ...newAddress.telephone };
            _telephone[field] = val;
            setNewAddress({ ...newAddress, telephone: _telephone })
          }} />*/}
        <CityLocationCombo
          className='w-12 md:w-3 mr-0 md:mr-2'
          value={selectedCity}
          label={intl.formatMessage({ id: "City" })}
          error={errorCity}
          onChange={(c: ComboDataDTO | null) => {
            setErrorCity(false);
            setNewAddress({ ...newAddress, city: c?.id ?? -1, citydesc: c?.name ?? "", cityExternalId: c?.isExternalId ?? false } as any);
            setSelectedCity(c);
          }}
        />
        <InputTextCustom
          className="w-12 md:w-2"
          label={"Código postal"}
          floatLabel
          value={newAddress.postalcode}
          onChange={(e: any) => {
            setNewAddress({ ...newAddress, postalcode: e.target.value });
          }} />
        <div className='flex flex-row' style={{ marginBottom: '8px' }}>
          {isEditing &&
            <div>
              <Button
                label="Cancelar"
                className='buttonSecondary buttonSecondary-primaryColor mr-2'
                onClick={cancelChanges} />
            </div>}
          <div>
            <Button
              icon="pi pi-plus"
              rounded
              disabled={newAddressTypes.length === 0}
              className='buttonSecondary buttonSecondary-primaryColor ml-2'
              onClick={() => {
                const resolvedAddress = {
                  ...newAddress,
                  city: selectedCity?.id ?? -1,
                  citydesc: selectedCity?.name ?? "",
                  cityExternalId: selectedCity?.isExternalId ?? false,
                };

                let errors = false;
                if (!selectedAddressTypes.length || !resolvedAddress.addressdesc || resolvedAddress.city < 0) {
                  (!resolvedAddress.types || resolvedAddress.types.length == 0) && setErrorType(true);
                  !resolvedAddress.addressdesc && setErrorDescription(true);
                  !selectedCity && setErrorCity(true);
                  errors = true;
                }
                if (errors) return;
                setNewAddress(resolvedAddress);
                onAddAddress(resolvedAddress);
                setSelectedAddressTypes([]);
              }} />
          </div>
        </div>
      </div>

    </div>
  )
}
